import map from 'lodash/map';
import every from 'lodash/every';
import zipObject from 'lodash/zipObject';
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import authenticationActivityApi from '../../../api/authenticationActivityApi';
import factoryOptionsApi from '../../../api/factoryOptionsApi';
// ---------------------------------------------------------------------

const REDUCER_NAME = 'authenticationActivity';

export const GetAuthenticationActivity = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getAuthenticationActivity`,
  async (params, thunkAPI) => {
    const res = await authenticationActivityApi.get(params);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateAuthenticationActivity = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateAuthenticationActivity`,
  async ({ data, id }, thunkAPI) => {
    const res = await authenticationActivityApi.update(data, id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateAuthenticationActivityStatus = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateAuthenticationActivityStatus`,
  async ({ status, id }, thunkAPI) => {
    const res = await authenticationActivityApi.updateStatus({ status }, id);

    if (res.status === 200) {
      return { status, id };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const DeleteAuthenticationActivity = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/deleteAuthenticationActivity`,
  async (id, thunkAPI) => {
    const res = await authenticationActivityApi.delete(id);

    if (res.status === 200) {
      return { id };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetFactoryOptions = createAsyncThunk(`${REDUCER_NAME}/getFactoryOptions`, async (__, thunkAPI) => {
  const optionNames = ['factoryConfig'];

  const optionResponses = await Promise.all(map(optionNames, (name) => factoryOptionsApi.getByName(name)));

  const allResponsesSuccessful = every(optionResponses, (res) => res.status === 200);

  if (allResponsesSuccessful) {
    const data = map(optionResponses, 'data');
    return zipObject(optionNames, data);
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
